import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from '@mui/styles'
import palette from '../../theme/palette';

const styles = theme => ({
  root: {
    display: 'inline-block',
    borderRadius: '50%',
    flexGrow: 0,
    flexShrink: 0
  },
  sm: {
    height: theme.spacing(1),
    width: theme.spacing(1)
  },
  md: {
    height: theme.spacing(2),
    width: theme.spacing(2)
  },
  lg: {
    height: theme.spacing(3),
    width: theme.spacing(3)
  },
  neutral: {
    backgroundColor: palette.common.neutral
  },
  primary: {
    backgroundColor: palette.primary.main
  },
  info: {
    backgroundColor: palette.info.main
  },
  warning: {
    backgroundColor: palette.warning.main
  },
  danger: {
    backgroundColor: palette.danger.main
  },
  success: {
    backgroundColor: palette.success.main
  }
});

const Status = ({ classes, className, size = 'md', color = 'default', ...rest }) => {

  const rootClassName = classNames(
    {
      [classes.root]: true,
      [classes[size]]: size,
      [classes[color]]: color
    },
    className
  );

  return (
    <span
      {...rest}
      className={rootClassName}
      //
    />
  );
};

Status.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  color: PropTypes.oneOf([
    'neutral',
    'primary',
    'info',
    'success',
    'warning',
    'danger'
  ]),
  size: PropTypes.oneOf(['sm', 'md', 'lg'])
};

// defaultProps removed in favor of default parameters

export default withStyles(styles)(Status);
